import React, { useEffect } from 'react';
import { Shield, Lock, Eye, FileText, Info, Home } from 'lucide-react';
import Footer from '../v3/footer.jsx';
import '../v3/pagesV3.css';

const PoliticasPrivacidadPesqueriaPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const publicUrl = process.env.PUBLIC_URL;

    return (
        <div id="pesqueria-v3-root" className="min-vh-100 d-flex flex-column">
            <div className="container-fluid p-0 flex-grow-1 fondo-gris">
                {/* Hero Section Simplificado */}
                <header className="bg-marine-900 py-5 text-white position-relative overflow-hidden" style={{ height: '320px' }}>
                    <video autoPlay muted loop className="video-background">
                        <source src="https://datos.ifop.cl/dev/videos/abate_video.mp4" type="video/mp4" />
                    </video>
                    <div className="video-overlay"></div>
                    <div className="position-absolute top-0 start-0 w-100 h-100 opacity-10">
                        <div className="bg-gradiente-marine w-100 h-100"></div>
                    </div>
                    <div className="container px-4 position-relative z-2">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-4 pt-4">
                            <div className="d-flex align-items-center gap-4">
                                <a className="align-self-start" href={`${publicUrl}/buscador-publico`}>
                                    <img src={`${publicUrl}/blanco.png`} alt="Logo IFOP" style={{ width: '100px' }} />
                                </a>
                                <div>
                                    <h1 className="display-6 fw-bold text-white mb-2 tracking-tight">
                                        POLÍTICAS DE <span className="text-marine-300">PRIVACIDAD</span>
                                    </h1>
                                    <nav aria-label="breadcrumb">
                                        {/* <ol className="breadcrumb mb-0">
                                            <li className="breadcrumb-item small"><a href={`${publicUrl}/buscador-publico-v3`} className="text-marine-200 text-decoration-none">Inicio</a></li>
                                            <li className="breadcrumb-item small text-white opacity-50 active" aria-current="page">Privacidad</li>
                                        </ol>*/}
                                    </nav>
                                </div>
                            </div>
                            <a href={`${publicUrl}/buscador-publico`} className="btn d-flex align-items-center gap-2 px-4 py-2 text-white rounded-3 border border-white border-opacity-10 shadow-sm" style={{ backgroundColor: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)' }}>
                                <Home size={16} />
                                <span className="small fw-semibold">Volver al Buscador</span>
                            </a>
                        </div>
                    </div>
                </header>

                <main className="container-xl_ px-0 py-1" style={{ position: 'relative', zIndex: '10', marginTop: '-64px' }}>
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-xl-9">
                            <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
                                <div className="card-body p-4 p-md-5 bg-white">

                                    <section className="mb-5">
                                        <div className="d-flex align-items-center gap-3 mb-4">
                                            <div className="bg-marine-100 p-3 rounded-4 text-marine-600">
                                                <Shield size={32} strokeWidth={1.5} />
                                            </div>
                                            <h2 className="h4 fw-bold text-marine-900 mb-0">Introducción</h2>
                                        </div>
                                        <p className="text-secondary leading-relaxed">
                                            El Instituto de Fomento Pesquero (IFOP) se compromete a proteger la privacidad y seguridad de los datos de los usuarios que acceden a nuestra plataforma de Buscador de Datos Pesqueros. Esta política describe cómo recopilamos, utilizamos y protegemos la información proporcionada.
                                        </p>
                                    </section>

                                    <hr className="my-2 border-light" />

                                    <div className="row g-5">
                                        <div className="col-md-6">
                                            <section className="h-100">
                                                <div className="d-flex align-items-center gap-3 mb-4">
                                                    <div className="bg-primary-subtle p-2 rounded-3 text-primary">
                                                        <Eye size={20} />
                                                    </div>
                                                    <h3 className="h5 fw-bold text-marine-800 mb-0">Recopilación de Datos</h3>
                                                </div>
                                                <p className="small text-secondary">
                                                    Nuestra plataforma recopila información técnica necesaria para el funcionamiento del servicio, tales como:
                                                </p>
                                                <ul className="small text-secondary ps-3">
                                                    <li className="mb-2">Dirección IP de acceso.</li>
                                                    <li className="mb-2">Tipo de navegador y sistema operativo.</li>
                                                    <li className="mb-2">Páginas visitadas y tiempo de navegación.</li>
                                                    <li className="mb-2">Búsquedas realizadas para mejorar la experiencia del usuario.</li>
                                                </ul>
                                            </section>
                                        </div>

                                        <div className="col-md-6">
                                            <section className="h-100">
                                                <div className="d-flex align-items-center gap-3 mb-4">
                                                    <div className="bg-success-subtle p-2 rounded-3 text-success">
                                                        <Lock size={20} />
                                                    </div>
                                                    <h3 className="h5 fw-bold text-marine-800 mb-0">Uso de la Información</h3>
                                                </div>
                                                <p className="small text-secondary">
                                                    La información recopilada se utiliza exclusivamente para:
                                                </p>
                                                <ul className="small text-secondary ps-3">
                                                    <li className="mb-2">Proveer y mantener el servicio de búsqueda.</li>
                                                    <li className="mb-2">Analizar tendencias de uso y estadísticas institucionales.</li>
                                                    <li className="mb-2">Garantizar la seguridad del sitio web y prevenir accesos no autorizados.</li>
                                                    <li className="mb-2">Cumplir con requerimientos legales o regulatorios.</li>
                                                </ul>
                                            </section>
                                        </div>
                                    </div>

                                    <hr className="my-2 border-light" />

                                    <section className="mb-5">
                                        <div className="d-flex align-items-center gap-3 mb-4">
                                            <div className="bg-info-subtle p-3 rounded-4 text-info-emphasis">
                                                <FileText size={32} strokeWidth={1.5} />
                                            </div>
                                            <h2 className="h4 fw-bold text-marine-900 mb-0">Protección y Seguridad</h2>
                                        </div>
                                        <div className="p-4 bg-light rounded-4 border-start border-marine-500 border-4">
                                            <p className="text-secondary mb-0">
                                                Implementamos medidas de seguridad técnicas y organizativas para proteger sus datos contra el acceso no autorizado, la pérdida accidental o la destrucción. El acceso a los datos está estrictamente limitado al personal autorizado del IFOP que necesita procesar dicha información para fines institucionales.
                                            </p>
                                        </div>
                                    </section>

                                    <section>
                                        <div className="d-flex align-items-center gap-3 mb-4">
                                            <div className="bg-warning-subtle p-3 rounded-4 text-warning-emphasis">
                                                <Info size={32} strokeWidth={1.5} />
                                            </div>
                                            <h2 className="h4 fw-bold text-marine-900 mb-0">Contacto y Actualizaciones</h2>
                                        </div>
                                        <p className="text-secondary">
                                            Esta política de privacidad puede ser actualizada periódicamente para reflejar cambios en nuestras prácticas o requerimientos legales. Le recomendamos revisar esta página regularmente.
                                        </p>
                                        <div className="alert alert-marine-light rounded-4 d-flex align-items-center gap-3 p-4">
                                            <div>
                                                <h4 className="h6 fw-bold mb-1">¿Tiene dudas sobre sus datos?</h4>
                                                <p className="small mb-0 opacity-75">Puede contactar con el Departamento de TI del IFOP a través de nuestros canales institucionales oficiales.</p>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
            <Footer />
        </div>
    );
};

export default PoliticasPrivacidadPesqueriaPage;
